import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as LogoVoliaSVG } from '../assets/img/logo-lifecell-tv.svg';
import scaleSize from '../utils/scale-size';

const LogoStyledContainer = styled.div`
  position: absolute;
  top: ${scaleSize(60)}px;
  left: ${scaleSize(220)}px;
  margin-top: ${(props) => scaleSize(props.hide ? -300 : 0)}px;
  transition: ${({ noAnimation }) => (!noAnimation ? `margin-top ease-out 0.3s` : 'none')};
`;

const Logo = (props) => <LogoStyledContainer {...props} />;

/*
 * This is a good way to add multiple logos
 * and do not extend components logic with conditions
 */
Logo.Volia = styled(LogoVoliaSVG)`
  width: ${scaleSize(225)}px;
  height: ${scaleSize(110)}px;
`;

Logo.propTypes = {
  hide: PropTypes.bool,
  children: PropTypes.element.isRequired,
};

export default Logo;
